import { Box } from '@machobear/design-system'

import { Button } from '@/components/button-new'

import { DSLoginStepProps } from './types'

type ExistingEmailProps = Pick<DSLoginStepProps, 'setCurrentStep' | 't'>

const ExistingEmailForDS: React.FC<ExistingEmailProps> = ({
  setCurrentStep,

  t
}) => {
  const registerRoute = 'register'
  return (
    <Box display="flex" gap="small" width="full">
      <Button
        id="web-register-existing-email-try-again-button"
        theme="secondary"
        width="100%"
        onClick={() => setCurrentStep(registerRoute)}
      >
        {t('b.auth.view.try_again.button', 'Try Again')}
      </Button>

      <Button
        id="web-register-existing-email-login-button"
        theme="primary"
        width="100%"
        onClick={() => setCurrentStep('login')}
      >
        {t('common.login', 'Log In')}
      </Button>
    </Box>
  )
}

export default ExistingEmailForDS
